import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../page/Home";
import About from "../page/About";
import ContactUs from "../page/ContactUs";
import Gallery from "../page/Gallery";
import Teams from "../page/Teams";
import Header from "../component/Header";
import Footer from "../component/Footer";
import Download from "../page/Download";
import ResultPage from "../page/ResultPage";
// import Login from "../page/Login";
// import SignUp from "../page/SignUp";
import AdminDashboard from "../page/AdminDashboard";

const AppRoute = ({ darkThemeStatus, setDarkThemeStatus }) => {
  return (
    <Router>
      <Header
        darkThemeStatus={darkThemeStatus}
        setDarkThemeStatus={setDarkThemeStatus}
      />
      <Routes>
        <Route exact path="/*" element={<Home />}></Route>
        <Route exact path="/" element={<Home />}></Route>
        <Route exact path="/about" element={<About />}></Route>
        <Route exact path="/contact" element={<ContactUs />}></Route>
        <Route exact path="/gallery" element={<Gallery />}></Route>
        <Route exact path="/teams" element={<Teams />}></Route>
        <Route exact path="/download" element={<Download />}></Route>
        {/* <Route exact path="/login" element={<Login />}></Route>
        <Route exact path="/signup" element={<SignUp />}></Route> */}
        <Route exact path="/dashboard" element={<AdminDashboard />}></Route>
        <Route
          exact
          path="/result/:phoneNumber/:dob"
          element={<ResultPage />}
        ></Route>
      </Routes>
      <Footer />
    </Router>
  );
};

export default AppRoute;
